module.exports = __webpack_public_path__ + "img/workspace-onboarding/share-your-video-befcc4cf4f443646cb9fceea455d7918.png";